var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-utl-nkning';
                    var viewUrl = 'gfx/sprite.svg#view-icon-utl-nkning';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 19',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };